module.exports = __webpack_public_path__ + "media/images/vp/icon.vote.star.gray-d79b7d32f65f559575dd5f02aca665d7.svg";